import { useLayoutEffect, useRef } from "react";
export function usePrevious(value) {
    const prevValueRef = useRef(undefined);
    useLayoutEffect(() => {
        prevValueRef.current = value;
    }, [value]);
    return prevValueRef.current;
}
